import * as tslib_1 from "tslib";
import { Component } from '../common/index';
var Command = /** @class */ (function (_super) {
    tslib_1.__extends(Command, _super);
    function Command(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'disable,icon,iconPosition,seperate,text,textAligment,click,template';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    Command.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "Command",
            "disable": this.disable,
            "icon": this.icon,
            "iconPosition": this.iconPosition,
            "seperate": this.seperate,
            "text": this.text,
            "textAligment": this.textAligment,
            "click": this.click,
            "template": this.template
        });
    };
    Command.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Command;
}(Component));
export { Command };
//# sourceMappingURL=command.js.map